import EpubCFI from "../epubcfi";
import {RangeObject} from "../utils/core";

class ExRangeObject extends RangeObject{
	constructor(doc){
		super();

		this.doc = doc;
	}

	toString() {
		let rangeParseResult = this.toStringProcess($("body", this.doc).get(0), this.startContainer, this.startOffset, this.endContainer, this.endOffset);
		this.doc = undefined;
		return rangeParseResult.totalString;
	}

	toStringProcess(node, startNode, startOffset, endNode, endOffset, status = "start"){
		let text = "";
		let nowParseResult = {
			totalString: "",
			status: status	
		};
		$(node).contents().each((index, node)=>{
			if(node === startNode){
				if(node.nodeType === 3){
					text = node.data.trim();
					if(text.length > 0){
						if(startOffset !== null){
							text = text.substring(startOffset, text.length);
						}
						nowParseResult.totalString += text;
					}
				}				
				nowParseResult.status = "goPares";
			}else if(node === endNode){
				if(node.nodeType === 3){
					text = node.data.trim();
					if(text.length > 0){
						if(startOffset !== null){
							text = text.substring(0, endOffset);
						}
						nowParseResult.totalString += `\n${text}`;
					}
				}
				nowParseResult.status = "complete";
				return false;
			}else{
				switch (node.nodeType){
					case 1 : if((nowParseResult.status === "start" || nowParseResult.status === "goPares") && $(node).contents().length){
								let subParseResult = this.toStringProcess(node, startNode, startOffset, endNode, endOffset, nowParseResult.status);
								nowParseResult.totalString = nowParseResult.totalString+subParseResult.totalString;
								nowParseResult.status = subParseResult.status;
								if(nowParseResult.status === "complete"){
									return false;
								}
							 }
							 break;
					case 3 : text = node.data.trim();
							 if(nowParseResult.status === "goPares" && text.length > 0){
								nowParseResult.totalString += `\n${text}`;
							 }
							 break;
				}
			}
		});
		return nowParseResult;
	}
}

class ExEpubCFI extends EpubCFI{
	constructor(cfiFrom, base, ignoreClass){
		super(cfiFrom, base, ignoreClass);
	}

	getRangeFromStartEndCFI(startCFI, endCFI){
		let cfiBase = startCFI.replace(/!.*/, "");
		let cfiStart = startCFI.replace(/.*!/, "").replace(/\)$/, "");
		let cfiEnd = endCFI.replace(/.*!/, "").replace(/\)$/, "");

		let theSamePartString = "";
		let goUpdateTheSamePartString = true;
		let cfiStartArray = cfiStart.split("/");
		let cfiEndArray = cfiEnd.split("/");
		for (let i = 0; i < cfiStartArray.length; i++) {
			if(cfiStartArray[i] !== "" && goUpdateTheSamePartString){
				if(!cfiStartArray[i].includes(":") && cfiStartArray[i] === cfiEndArray[i]){
					theSamePartString += `/${cfiStartArray[i]}`;
				}else{
					goUpdateTheSamePartString = false;
				}
			}
		}
		return `${cfiBase}!${theSamePartString},${cfiStart.replace(theSamePartString,"")},${cfiEnd.replace(theSamePartString,"")})`;
	}

	getCFIFromOldCFI(oldCFI){
		let bodyboxRegex = /[\/]{1}[\d]+(\[bodybox\])/g;
		return oldCFI.replace(bodyboxRegex,"");
	}

	getRangeFromOldRange(oldRangeCFI){
		let bodyboxRegex = /[\/]{1}[\d]+(\[bodybox\])/g;
		oldRangeCFI = oldRangeCFI.replace(bodyboxRegex,"");
		let cfiParts = oldRangeCFI.split(",");
		if(cfiParts.length === 2){
			let cfiBase = cfiParts[0].replace(/!.*/, "");
			let cfiStart = cfiParts[0].replace(/.*!/, "").replace(/\)$/, "");
			let cfiEnd = cfiParts[1].replace(/.*!/, "").replace(/\)$/, "");
			let theSamePartString = "";
			let goUpdateTheSamePartString = true;
			let cfiStartArray = cfiStart.split("/");
			let cfiEndArray = cfiEnd.split("/");
			for (let i = 0; i < cfiStartArray.length; i++) {
				if(cfiStartArray[i] !== "" && goUpdateTheSamePartString){
					if(!cfiStartArray[i].includes(":") && cfiStartArray[i] === cfiEndArray[i]){
						theSamePartString += `/${cfiStartArray[i]}`;
					}else{
						goUpdateTheSamePartString = false;
					}
				}
			}
			return `${cfiBase}!${theSamePartString},${cfiStart.replace(theSamePartString,"")},${cfiEnd.replace(theSamePartString,"")})`;
		}else{
			return oldRangeCFI;
		}
	}

	conventRangeToOldRange(newRangeCFI, isAddBodyBox){
		let cfiParts = newRangeCFI.split(",");
		let cfiBase = cfiParts[0].replace(/!.*/, "");
		let theSamePartString =  cfiParts[0].replace(/.*!/, "").replace(/\)$/, "");
		let cfiStart = cfiParts[1].replace(/.*!/, "").replace(/\)$/, "");
		let cfiEnd = cfiParts[2].replace(/.*!/, "").replace(/\)$/, "");
		if(isAddBodyBox){
			let theSamePart = theSamePartString.split("/");
			theSamePart.shift();
			theSamePartString = "";
			theSamePart.forEach((cfiString,index)=>{
				if(index === 0){
					theSamePartString += `/${cfiString}/2[bodybox]`;
				}else{
					theSamePartString += `/${cfiString}`;
				}
			});
			return `${cfiBase}!${theSamePartString}${cfiStart},${theSamePartString}${cfiEnd})`;
		}else{
			return `${cfiBase}!${theSamePartString}${cfiStart},${theSamePartString}${cfiEnd})`;
		}
	}

	conventCFIToOldCFI(newCFI){
		let cfiBase = newCFI.replace(/!.*/, "");
		let cfiStart = newCFI.replace(/.*!/, "").replace(/\)$/, "");
		let cfiStartPart = cfiStart.split("/");
		cfiStartPart.shift();
		cfiStart = "";
		cfiStartPart.forEach((cfiString, index)=>{
			if(index === 0){
				cfiStart += `/${cfiString}/2[bodybox]`;
			}else{
				cfiStart += `/${cfiString}`;
			}
		});
		return `${cfiBase}!${cfiStart})`;
	}

	getStartCFIFromRange(rangeCFI){
		let CFIArray = rangeCFI.split(",");
		return CFIArray[0]+CFIArray[1]+")";
	}

	getEndCFIFromRange(rangeCFI){
		let CFIArray = rangeCFI.split(",");
		return CFIArray[0]+CFIArray[2];
	}

	isCpctString(str) {
		if(str && typeof str === "string"){
			var content = str.split("(").pop().split(")").shift();
			return new RegExp(/^[^\/]\d*\/[^\/]\d*\/[^\/]\d*$/).test(content);
		}else{
			return false;
		}
	}

	isCfiRangeString(str){
		let isCfiRangeString = false;
		if(typeof str === "string"){
			let cfiArray = str.split(",");
			if(cfiArray.length > 1){
				isCfiRangeString = true;
			}
		}
		return isCfiRangeString;
	}

	getStartFromCfiRangeString(str){
		let startCfi = undefined, cfiArray = str.split(",");
		switch(cfiArray.length){
			case 2: startCfi = `${cfiArray[0]})`;
					break;
			case 3: startCfi = `${cfiArray[0]}${cfiArray[1]})`;
					break;
		}
		return startCfi;
	}

	getSpineIndexFromCpct(cpctStr){
		let parsedStr = cpctStr.slice().split("(").pop().split(")").shift().split("/");
		return parsedStr[0];
	}

	getSpinePercentageFromCpct(cpctStr){
		let parsedStr = cpctStr.slice().split("(").pop().split(")").shift().split("/");
		return ((parseInt(parsedStr[1],10)/parseInt(parsedStr[2],10)) * 100).toFixed(3);
	}

	parseComponent(componentStr){
		var component = {
			steps: [],
			terminal: {
				offset: null,
				assertion: null
			}
		};
		var parts = componentStr.split(":");
		var steps = parts[0].split("/");
		var terminal;

		if(parts.length > 1) {
			terminal = parts[1];
			component.terminal = this.parseTerminal(terminal);
		}

		if (steps[0] === "") {
			steps.shift(); // Ignore the first slash
		}

		//加入結尾過濾
		if (steps[steps.length-1] === "") {
			steps.pop();
		}

		component.steps = steps.map(function(step){
			return this.parseStep(step);
		}.bind(this));

		return component;
	}

	/**
	 * Creates a DOM range representing a CFI
	 * @param {document} _doc document referenced in the base
	 * @param {string} [ignoreClass]
	 * @return {Range}
	 */
	 toRange(_doc, ignoreClass) {
		var doc = _doc || document;
		var range;
		var start, end, startContainer, endContainer;
		var cfi = this;
		var startSteps, endSteps;
		var needsIgnoring = ignoreClass ? (doc.querySelector("." + ignoreClass) != null) : false;
		var missed;

		if (typeof(doc.createRange) !== "undefined") {
			range = doc.createRange();
		} else {
			//用 ExRangeObject 取代 RangeObject 物件
			range = new ExRangeObject(doc);
		}

		if (cfi.range) {
			start = cfi.start;
			startSteps = cfi.path.steps.concat(start.steps);
			startContainer = this.findNode(startSteps, doc, needsIgnoring ? ignoreClass : null);
			end = cfi.end;
			endSteps = cfi.path.steps.concat(end.steps);
			endContainer = this.findNode(endSteps, doc, needsIgnoring ? ignoreClass : null);
		} else {
			start = cfi.path;
			startSteps = cfi.path.steps;
			startContainer = this.findNode(cfi.path.steps, doc, needsIgnoring ? ignoreClass : null);
		}

		if(startContainer) {
			try {
				if(start.terminal.offset != null) {
					range.setStart(startContainer, start.terminal.offset);
				} else {
					range.setStart(startContainer, 0);
				}

			} catch (e) {
				missed = this.fixMiss(startSteps, start.terminal.offset, doc, needsIgnoring ? ignoreClass : null);
				try {
					range.setStart(missed.container, missed.offset);
				} catch (e) {
					console.log(e);
					return null;
				}
			}
		} else {
			console.log("No startContainer found for", this.toString());
			// No start found
			return null;
		}

		if (endContainer) {
			try {

				if(end.terminal.offset != null) {
					range.setEnd(endContainer, end.terminal.offset);
				} else {
					range.setEnd(endContainer, 0);
				}

			} catch (e) {
				missed = this.fixMiss(endSteps, cfi.end.terminal.offset, doc, needsIgnoring ? ignoreClass : null);
				range.setEnd(missed.container, missed.offset);
			}
		}

		// doc.defaultView.getSelection().addRange(range);
		return range;
	}

	comparePage(cpctOne, cpctTwo){
		let cpctOneArray = cpctOne.split("/");
		let cpctTwoArray = cpctTwo.split("/");
		let cpctOnePage = parseInt(cpctOneArray[0], 10) + 1 + (parseInt(cpctOneArray[1], 10) / parseInt(cpctOneArray[2], 10));
		let cpctTwoPage = parseInt(cpctTwoArray[0], 10) + 1 + (parseInt(cpctTwoArray[1], 10) / parseInt(cpctTwoArray[2], 10));
		return (cpctOnePage < cpctTwoPage) ? -1 : 1;
	}

	/**
	 * Compare which of two CFIs is earlier in the text
	 * @returns {number} First is earlier = -1, Second is earlier = 1, They are equal = 0
	 */
	compare(cfiOne, cfiTwo) {
		var stepsA, stepsB;
		var terminalA, terminalB;

		var rangeAStartSteps, rangeAEndSteps;
		var rangeBEndSteps, rangeBEndSteps;
		var rangeAStartTerminal, rangeAEndTerminal;
		var rangeBStartTerminal, rangeBEndTerminal;

		if(typeof cfiOne === "string") {
			//置換ExEpubCFI
			cfiOne = new ExEpubCFI(cfiOne);
		}
		if(typeof cfiTwo === "string") {
			//置換ExEpubCFI
			cfiTwo = new ExEpubCFI(cfiTwo);
		}
		// Compare Spine Positions
		if(cfiOne.spinePos > cfiTwo.spinePos) {
			return 1;
		}
		if(cfiOne.spinePos < cfiTwo.spinePos) {
			return -1;
		}

		if (cfiOne.range) {
			stepsA = cfiOne.path.steps.concat(cfiOne.start.steps);
			terminalA = cfiOne.start.terminal;
		} else {
			stepsA = cfiOne.path.steps;
			terminalA = cfiOne.path.terminal;
		}

		if (cfiTwo.range) {
			stepsB = cfiTwo.path.steps.concat(cfiTwo.start.steps);
			terminalB = cfiTwo.start.terminal;
		} else {
			stepsB = cfiTwo.path.steps;
			terminalB = cfiTwo.path.terminal;
		}

		// Compare Each Step in the First item
		for (var i = 0; i < stepsA.length; i++) {
			if(!stepsA[i]) {
				return -1;
			}
			if(!stepsB[i]) {
				return 1;
			}
			if(stepsA[i].index > stepsB[i].index) {
				return 1;
			}
			if(stepsA[i].index < stepsB[i].index) {
				return -1;
			}
			// Otherwise continue checking
		}

		// All steps in First equal to Second and First is Less Specific
		if(stepsA.length < stepsB.length) {
			return -1;
		}

		// Compare the charecter offset of the text node
		if(terminalA.offset > terminalB.offset) {
			return 1;
		}
		if(terminalA.offset < terminalB.offset) {
			return -1;
		}

		// CFI's are equal
		return 0;
	}

	findNode(steps, _doc, ignoreClass) {
		var doc = _doc || document;
		var container;
		var xpath;

		if(!ignoreClass && typeof doc.evaluate != "undefined") {
			xpath = this.stepsToXpath(steps);
			container = doc.evaluate(xpath, doc, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
			//找不到時, 往上一層找
			if(!container){
				steps.splice(-1);
				xpath = this.stepsToXpath(steps);
				container = doc.evaluate(xpath, doc, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
			}
		} else if(ignoreClass) {
			container = this.walkToNode(steps, doc, ignoreClass);
		} else {
			container = this.walkToNode(steps, doc);
		}

		return container;
	}

}

export default ExEpubCFI;